const findSpacesByAreaSelection = (
  [start, end],
  { dx, dy, spaces, xScale, yScale, transform: t }
) => {
  const x1 = start[0] - dx * t.k
  const y1 = start[1] - dy * t.k
  const x2 = end[0] - dx * t.k
  const y2 = end[1] - dy * t.k
  let result

  spaces.ids.forEach((id, i) => {
    const space = spaces.byId[id]
    const x = xScale(space.x)
    const y = yScale(space.y)

    if (x1 <= x && x2 >= x && y1 <= y && y2 >= y) {
      result = result ? [...result, space.id] : [space.id]
    }
  })

  return result
}

export default findSpacesByAreaSelection
